var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.332031 13.0648L5.98731 18.7201L7.39731 17.3001L1.74702 11.6499L0.332031 13.0648ZM22.2466 5.28088L11.6473 15.8901L7.41045 11.6433L5.98045 13.0533L11.6473 18.7201L23.6666 6.70088L22.2466 5.28088ZM18.0081 6.6993L16.5981 5.2793L10.2273 11.6501L11.6473 13.0601L18.0081 6.6993Z",
    fill: "#2F7DF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckAll);
export default __webpack_public_path__ + "static/media/check-all.b86543780c30b3b539dc9844213ac09d.svg";
export { ForwardRef as ReactComponent };